<template>
  <LogoSvgCa
    v-if="canShowCanadianLogo"
    :class="computedClasses"
  />
  <LogoSvg
    v-else
    :class="computedClasses"
  />
</template>

<script setup lang="ts">
import LogoSvg from '~/assets/images/logo-rvezy.svg'
import LogoSvgCa from '~/assets/images/logo-rvezy-ca.svg'

const props = defineProps<{
  variant?: 'standard' | 'white'
}>()

const { showCanadianOwnerBanner } = useExperiment()

const route = useRoute()
const canShowCanadianLogo = computed(() => {
  return route.meta.layout !== 'static' && showCanadianOwnerBanner.value
})

const computedClasses = computed(() => {
  return {
    '[&>path]:fill-white': props.variant === 'white',
  }
})
</script>
